var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7188 10.1416C40.0312 9.90723 40.5 10.1416 40.5 10.5322V26.4697C40.5 28.5791 38.7812 30.2197 36.75 30.2197H4.25C2.14062 30.2197 0.5 28.5791 0.5 26.4697V10.5322C0.5 10.1416 0.890625 9.90723 1.20312 10.1416C3 11.5479 5.26562 13.2666 13.2344 19.0479C14.875 20.2197 17.6875 22.7979 20.5 22.7979C23.2344 22.7979 26.125 20.2197 27.6875 19.0479C35.6562 13.2666 37.9219 11.5479 39.7188 10.1416ZM20.5 20.2197C18.625 20.2979 16.0469 17.9541 14.7188 17.0166C4.32812 9.5166 3.54688 8.81348 1.20312 6.93848C0.734375 6.62598 0.5 6.0791 0.5 5.4541V3.96973C0.5 1.93848 2.14062 0.219727 4.25 0.219727H36.75C38.7812 0.219727 40.5 1.93848 40.5 3.96973V5.4541C40.5 6.0791 40.1875 6.62598 39.7188 6.93848C37.375 8.81348 36.5938 9.5166 26.2031 17.0166C24.875 17.9541 22.2969 20.2979 20.5 20.2197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSymbol);
export default __webpack_public_path__ + "static/media/EmailSymbol.ac76d34c88f5f89e5d359a1ad2a760c6.svg";
export { ForwardRef as ReactComponent };